import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";

export const getOrganizationDocument = documentId => {
  return dispatch => {
    dispatch({ type: "GET_ORGANIZATION_DOCUMENT_LOADING" });
    api
      .organizationDocumentGet(documentId)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchOrganizationDocumentAlertTitle",
          "Virhe yrityksen dokumentin noutamisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_ORGANIZATION_DOCUMENT_SUCCEEDED",
  payload: { organizationDocument: data },
});

const operationFail = () => ({
  type: "GET_ORGANIZATION_DOCUMENT_FAIL"
});
